export const TEST_CASE_MESSAGE_COMPONENTS = (comp) => ({
  SHOULD_RENDER_SUCCESSFULLY: `Component ${comp} inside ChatPreview should render successfully`,
});

// index ChatPreview
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_INDEX =
  'chat-page-main-content-chat-preview-index';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_IMAGE =
  'chat-page-main-content-chat-preview-image';

// HeaderPreview
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_HEADER =
  'chat-page-main-content-chat-preview-header';

// TextPreview
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_TEXT =
  'chat-page-main-content-chat-preview-text';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_TEXT_READ_MORE =
  'chat-page-main-content-chat-preview-text-read-more';

// NewsPreview
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_NEWS =
  'chat-page-main-content-chat-preview-news';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_NEWS_IMAGE =
  'chat-page-main-content-chat-preview-news-image';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_NEWS_TITLE =
  'chat-page-main-content-chat-preview-news-title';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_NEWS_FEED_LABEL =
  'chat-page-main-content-chat-preview-news-feed-label';

// ReportPreview
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPORT =
  'chat-page-main-content-chat-preview-report';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPORT_CONTENT =
  'chat-page-main-content-chat-preview-report-content';

// PollingPreview
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_POLLING =
  'chat-page-main-content-chat-preview-polling';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_POLLING_ICON =
  'chat-page-main-content-chat-preview-polling-icon';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_POLLING_BTN =
  'chat-page-main-content-chat-preview-polling-btn';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_POLLING_TOTAL_VOTERS =
  'chat-page-main-content-chat-preview-polling-total-voters';

// YoutubePreview
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_YOUTUBE =
  'chat-page-main-content-chat-preview-youtube';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_YOUTUBE_COVER =
  'chat-page-main-content-chat-preview-youtube-cover';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_YOUTUBE_PLAY_BTN =
  'chat-page-main-content-chat-preview-youtube-play-btn';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_YOUTUBE_TITLE =
  'chat-page-main-content-chat-preview-youtube-title';

// AttachmentPreview
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_ATTACHMENT =
  'chat-page-main-content-chat-preview-attachment';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_ATTACHMENT_TITLE =
  'chat-page-main-content-chat-preview-attachment-title';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_ATTACHMENT_FILENAME =
  'chat-page-main-content-chat-preview-attachment-file-name';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_ATTACHMENT_PDF =
  'chat-page-main-content-chat-preview-attachment-pdf';

// PredictionPreview
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION =
  'chat-page-main-content-chat-preview-prediction';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_ICON =
  'chat-page-main-content-chat-preview-prediction-icon';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_LABEL =
  'chat-page-main-content-chat-preview-prediction-label';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_SYMBOL_NAME =
  'chat-page-main-content-chat-preview-prediction-symbol-name';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_TARGET_PRICE =
  'chat-page-main-content-chat-preview-prediction-target-price';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_INITIAL_PRICE =
  'chat-page-main-content-chat-preview-prediction-initial-price';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_PERCENTAGE =
  'chat-page-main-content-chat-preview-prediction-percentage';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_TIMING =
  'chat-page-main-content-chat-preview-prediction-timing';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_DISAGREE_BTN =
  'chat-page-main-content-chat-preview-prediction-disagree-btn';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_AGREE_BTN =
  'chat-page-main-content-chat-preview-prediction-agree-btn';

// RepostBox
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX =
  'chat-page-main-content-chat-preview-repost-box';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_UNAVAILABLE =
  'chat-page-main-content-chat-preview-repost-box-unavailable';

export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_AVATAR =
  'chat-page-main-content-chat-preview-repost-box-avatar';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_USERNAME =
  'chat-page-main-content-chat-preview-repost-box-username';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_IMAGE =
  'chat-page-main-content-chat-preview-repost-box-image';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_TITLE =
  'chat-page-main-content-chat-preview-repost-box-title';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_CONTENT =
  'chat-page-main-content-chat-preview-repost-box-content';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_YOUTUBE_PLAYER =
  'chat-page-main-content-chat-preview-repost-box-youtube-player';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_NEWS_SOURCE =
  'chat-page-main-content-chat-preview-repost-box-news-source';
export const DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_DOCUMENT_ATTACHMENT =
  'chat-page-main-content-chat-preview-repost-box-document-attachment';
